export default __webpack_public_path__ + "static/media/STL-Investors-Meet-June-25.8f400372.pdf";